module.exports = __webpack_public_path__ + "static/media/notification_wrapper.45163501.png";